import { computedFrom, transient } from "aurelia-framework";
import { BaseRuleConfigPlugin } from "./base-rule-config-plugin";
import { RfiTemplateCategoryEnum } from "../../../../../../../models/vetting/vetting.models";
import { LookupValue } from "@rightship-tech/common-ui/models/lookup.models";

@transient()
export class RequireRfi extends BaseRuleConfigPlugin 
{
    public overrideBuLevelConfig: boolean;
    private _subtaskType: LookupValue

    public showDocumentManagementMeta: boolean = false;

    @computedFrom('meta', 'meta.subtaskType')
    public get subtaskType()
    {
        return this._subtaskType;
    }

    public set subtaskType(value: LookupValue)
    {
        this._subtaskType = value;

        if(value?.additionalData?.rfiTemplateCategoryId == RfiTemplateCategoryEnum.DocumentManagement)
        {
            this.showDocumentManagementMeta = true;
        }
        else 
        {
            this.showDocumentManagementMeta = false;
        }
    }
}